/**
 * `/konto/google` — the moment between Google's consent page and the Kalendarz tab. It draws
 * `/konto`'s own header, strip and column with Kalendarz selected — the tab exists by definition
 * after a return from Google — so the replace onto the tab changes ink and not geometry.
 */

import { useTranslation } from 'react-i18next';

import { useDocumentTitle } from '~/shared/lib/useDocumentTitle';
import { TabStrip, tabButtonId, tabPanelId } from '~/shared/ui/TabStrip';
import header from '~/shared/ui/screenHeader.module.css';
import shell from '~/shared/ui/canonScreen.module.css';

import { useGoogleCalendarReturn } from '../lib/useGoogleCalendarReturn';
import { accountTabLabel, visibleAccountTabs } from '../model/accountTabs';
import { CalendarCard } from './CalendarCard';
import styles from './AccountScreen.module.css';

export function GoogleCalendarReturnScreen() {
  const { t } = useTranslation();
  useDocumentTitle(t('web:account.title'));
  const onSelectTab = useGoogleCalendarReturn();

  return (
    <main className={shell.page}>
      <div className={styles.columns}>
        <div className={styles.sheet}>
          <div className={styles.header}>
            <div className={`${String(header.titleRow)} ${String(styles.titleRow)}`}>
              <h1 className={header.title}>{t('web:account.title')}</h1>
            </div>
          </div>

          <TabStrip
            className={styles.tabBar}
            label={t('web:account.tabsLabel')}
            tabs={visibleAccountTabs(true)}
            selected="integracje"
            renderLabel={(entry) => accountTabLabel(entry, t)}
            onSelect={onSelectTab}
          />

          <div
            className={styles.panel}
            role="tabpanel"
            id={tabPanelId('integracje')}
            aria-labelledby={tabButtonId('integracje')}
            tabIndex={0}
          >
            <div className={styles.inner}>
              <p className={`${String(styles.ledeText)} ${String(styles.lede)}`}>
                {t('web:account.calendar.lede')}
              </p>
              <div className={styles.block}>
                {/* Plain text: the h1 takes focus on arrival, and the tab says the outcome. */}
                <p className={styles.rowTitle}>{t('web:account.calendar.webReturnWorking')}</p>
              </div>
            </div>
          </div>
        </div>
        <aside className={styles.side} aria-label={t('web:account.tabs.integracje')}>
          <CalendarCard />
        </aside>
      </div>
    </main>
  );
}
